import { render, staticRenderFns } from "./complete.vue?vue&type=template&id=6b4f88c4"
import script from "./complete.vue?vue&type=script&lang=js"
export * from "./complete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports